import styled, { css } from 'styled-components';
import { Button } from 'reactstrap';
import { HTMLProps } from 'react';

const CommonMobileButtonCss = css`
        text-shadow: none;
    }
`
const CommonMobileButtonSegundoCss = css`
        text-shadow: none;
    }
`

interface MobileButtonProps extends HTMLProps<Button>{
    $variant?: string
}
export const MobileButton = styled(Button)<MobileButtonProps>`
    
`

interface MobileLinkProps extends HTMLProps<HTMLAnchorElement>{
    $variant?: string
}
export const MobileLink = styled.a<MobileLinkProps>`
    
`

export const MobileButtonOrganizer = styled.div`
    /*
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    row-gap: 16px;
    column-gap: 8px;
    position: fixed;
    bottom: 0px;
    background-color: rgba(var(--branco), 1);
    padding: 16px 8px;
    border-top: 1px solid rgba(var(--cor-tema), .3);
    box-shadow: 0 0px 16px 0px rgba(var(--cor-tema), .3);
    width: 100%;
    z-index:1;
    */
    ${MobileButton}{
        /*flex: 1 1 calc(50% - 10px);*/
        /*box-sizing: border-box;*/
    }

    @media (max-width: 500px) {
        /*flex: 1 1 100%;*/
    }
`


